import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { getBoardNote } from "../lib/api";
import { ErrorBox, Loading, PageHeader } from "../components/Shell";
import { BoardNote } from "../components/BoardNote";
import { TrustBadge } from "../components/TrustBadge";

/** The whole portfolio on one printable page for a board or CSR committee meeting. */
export default function BoardNotePage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    getBoardNote().then(setData).catch(setErr);
  }, []);

  const fy = data?.portfolio?.fy_range || [];

  return (
    <div data-testid="board-note-page">
      <div className="print:hidden">
        <PageHeader
          overline="Board note"
          title="The portfolio on one page"
          testId="board-note-header"
          actions={
            <button
              onClick={() => window.print()}
              data-testid="print-board-note-button"
              className="inline-flex items-center gap-2 bg-[#A01236] text-white rounded-xl px-4 py-2.5 text-[13px] font-medium hover:bg-[#760D28] transition-colors"
            >
              <Printer className="w-4 h-4" /> Print or save as PDF
            </button>
          }
        >
          Spend, delivery, partners and peer position — every figure the same as on its own screen.
        </PageHeader>
      </div>

      {err && <ErrorBox error={err} />}
      {!data && !err && <Loading />}

      {data && (
        <article className="space-y-4 max-w-5xl" data-testid="board-note-body">
          <header className="hidden print:block border-b border-stone-300 pb-3 mb-3">
            <div className="text-[12px] font-semibold text-[#A01236]">Bajaj Finserv CSR · board note</div>
            <h1 className="text-[22px] font-bold">Portfolio position</h1>
            <p className="text-[12px] text-stone-600">
              mGrant portfolio {fy[0]}–{fy[fy.length - 1]} · prepared {new Date().toISOString().slice(0, 10)}
            </p>
          </header>
          <div className="print:hidden">
            <TrustBadge answerability={data.answerability} testId="board-note-trust" />
          </div>
          <BoardNote note={data} />
        </article>
      )}
    </div>
  );
}
